export const endPoints = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || "http://localhost:5050/",
  imageCDN: "https://cdn.spinsagacasino.com:5000/",
  api: {
    geocomplyLience1: "geocomplyLience1",
    LOGIN_ENDPOINT: "casino/users/login", //  "users/login",
    SIGNUP: "casino/users/fullsignup", //"users/signup",
    GET_BY_USERID: "users/userid", // 12  Append userid
    GET_BY_USERNAME: "users/username/", // userrname
    UPDATE_PERSONAL: "users/personal",
    UPDATE_LANGUAGE: "user/language/update",
    UPDATE_CURRENCY: "user/currency/update",
    UPDATE_PROFILE_IMAGE: "upload/profileimage",
    EMAIL_SUPPORT: "/casino/email/support",
    VERIFICATION_ENDPOINT: "users/validate",
    STATES: "states",
    UPDATE_EMAIL: "/users/casino/email",
    FORGOT_PASSWORD: "casino/users/passwordlost/",
    GET_SPORTS_DATA: "api/sports/id", //sportsid 6046
    CHANGE_PASS: "users/password",
    GET_QUESTIONS: "questions",
    GET_DOCUMENTS: "documentTypes",
    transactions: "alltransactions",
    activations: "activations",
    ssnVerification: "api/ssn/verification",
    Reset_password: "reset/password",
    resendMail: "casino/user/resend", //'user/resend',
    GetUserLimit: "user/limit/",
    SetUserLimit: "user/limit",
    brochures: "brochures",
    brochureDetails: "brochureDetails",
    order: "transactions/order",
    ordersHistory: "orders",
    apiurl: "casino/user/kyc/token",
    banking_withdraw: "banking/withdrawals",
    kyc_verify: "user/kyc/verify/",
    promo: "/promo/apply",
    GET_BANNER: "activepromotions",
    GOOGLE_LOGIN: "casino/user/loginwithgoogle",
    USER_PROFILE: "user/profile",
    GET_GAMES: "api/casino/games",
    GET_MENU: "api/casino/menu",
    GET_GAME_BY_MENU_ID: "api/casino/gamesbymenu",
    GET_ACTIVE_GAMES: "api/casino/activegames",
    // GET_PROMO:'api/casino/promosadmin',
    GET_PROMO: "api/casino/promos",
    PROMO_VALIDATE: "api/v1/promotions/validate",
    PROMO_REDEEM: "api/v1/promotions/redeem",
    GET_PACKAGE: "api/casino/packages",
    // Single package by its numeric id, unlike GET_PACKAGE's per-player filtered list.
    GET_PACKAGE_BY_ID: "api/casino/package",
    MANUAL_DEPOSIT_CONFIG: "api/casino/manualdepositconfig",
    GET_EXCHANGE: "api/casino/favgifts",
    GET_FEATURE_GAME: "api/casino/featuregames",
    BUY_COIN: "api/casino/buycoin",
    BUY_GIFT: "api/casino/buygift",
    // COIN_TRANSACTION:'api/casino/getBuyCoins',
    GIFT_TRANSACTION: "api/casino/getGifts",
    LOYALTY_DATA: "api/bench/getuserLevel",
    USER_TRACE: "casino/user/logintrace", //'user/logintrace',
    USER_AVAILABILTY: "users/username",
    EMAIL_AVAIALBILTY: "users/email",
    USER_SIGNUP: "casino/users/fullsignup",
    RADAR_API: "api/radar/search",
    EMAIL_POPUP: "user/emailpopup",
    SKRILL_PAYMENT: "skrill/payment/addpayment",
    CASINO_PLAY: "casinoplay/create",
    COIN_TRANSACTION: "casinoskrill/payment/transactions",
    GET_FAVORITE: "api/casino/favgames",
    ADD_FAVORITE: "api/casino/gameaddtofav",
    REMOVE_FAVORITE: "api/casino/removefavGame",
    REMOVE_FEATURE_FAVORITE: "api/casino/removeFeaturefavGame",
    REMOVE_GIFT_FAVORITE: "api/casino/removefavGift",
    ADD_GIFT_FAVORITE: "api/casino/giftaddtofav",
    GET_FEATURE_FAVORITE: "api/casino/Featurefavgames",
    DAILY_FREE_COIN: "api/casino/dailyfree",
    OTP_VERIFICATION: "casino/user/otpverification",
    HOME_PAGE: "api/casino/homepage",
    GAME_HISTORY: "casinoplay/user/gamelist", // "casinoplay/gametrasactions",
    SERACH_GAME: "api/casino/searchgames",
    USER_COOLOFF: "/user/cooloff",
    USER_EXCLUDE: "/user/exclude",
    USER_CASINO_UPDATE: "users/update",
    REFERAL_TABLE: "referUsers",
    COIN_TRNASFER: "/user/coin/transfer",
    CANCEL_REDEEMPTION: "api/casino/cancelbuycoin",
    GET_PAYMENTS: "getPaymentMode",
    GET_DAILY_CLAIM: "casino/user/dailyClaim",
    SKRILL_WITHDRAW: "skrill/payment/withdrawfunds",
    GET_CONFIGURATION: "api/configuration/all",
    GIFT_CASH_TRANSACTION: "withdraw/",
    CANCEL_CASH_TRANSACTION: "transactions/cancel",
    GET_VIP_PACKAGES: "api/bench/packages",
    USER_VIP_LEVEL: "api/bench/getuserlevel",
    POST_SOCIAL_URL: "post/add",
    USER_TRANSACTION: "/user/transactions",
    USER_POST_DETAIL: "post/get",
    GET_SPIN_VALUES: "casino/v2/user/spin",
    GET_SPIN_PRIZE: "casino/user/dailySpinClaim",
    POPUP_RESOLVE: "api/popups/resolve",
    POPUP_TRACK: "api/popups/track",
    POPUP_CLAIM: "api/popups/claim",
    POPUP_WOF_ALL: "api/popupWof/all",
    POPUP_WOF_CLAIM: "api/popupWof/claim",
    POPUP_STATE_BIGWIN: "api/popups/bigwin",
    POPUP_STATE_COINS_EXPIRING: "api/popups/coinsexpiring",
    POPUP_STATE_DEPOSIT_LAPSED: "api/popups/depositlapsed",
    POPUP_STATE_FREESPIN_PENDING: "api/popups/freespinpending",
    POPUP_STATE_REDEMPTION_PENDING: "api/popups/redemptionpending",
    POPUP_STATE_WITHDRAWAL_COMPLETE: "api/popups/withdrawalcomplete",
    POPUP_STATE_TIER_UPGRADE_CLOSE: "api/popups/tierupgradeclose",
    POPUP_STATE_HIGH_CASH_NO_WAGER: "api/popups/highcashnowager",
    POPUP_STATE_DEPOSIT_CONFIRMING: "api/popups/depositconfirming",
    POPUP_STATE_DEPOSIT_CONFIRMED: "api/popups/depositconfirmed",
    POPUP_STATE_WITHDRAWAL_BROADCASTING: "api/popups/withdrawalbroadcasting",
    MAIL_IN_FEATURE: "promo/email/add",
    REDEEM_CODE: "promo/apply",
    HOME_PAGE_BY_CATEGORY: "api/casino/homepagecategory",
    GET_GAMES_BY_CATEGORY_NAME: "api/casino/gamesbycategory",
    RECENTLY_PLAYED: "api/casino/recentlyplayed",
    SHOW_POPUP: "user/transpopup",
    SKIP_POPUP: "user/skippopup",
    BIRTHDAY_CLAIM: "casino/user/birthDayClaim",
    SKRIL_CARD_WITHDRAW: "casinoskrill/payment/withdrawfundsCard",
    MULTIPLIER_CLAIM: "casino/user/dailyClaim",
    GIFT_CARD_TRANSACTION: "cardwithdraw/",
    CRYPTO_REDEEM:'casinoskrill/payment/withdrawfundsCrypto',
    CRYPTO_TRANSACTION_BY_USERID:'cryptowithdraw/',
    MONTHLY_REWARDS:'monthlyRewards/user/all',
    GET_ALL_STREAK_TYPES:'streakType/user',
    UPDATE_STREAK_TYPE:'api/rewards/streak-type/update',
    NEW_STREAK:'api/rewards/streak/new',
    START_FRESH_STREAK:'api/rewards/streak/start-fresh',
    CLAIM_MONTHLY_REWARD:'api/rewards/claim',
    RECENT_FREE_SPIN_GAMES:'freeround/history',
    GET_BOOSTER_PACKAGES:'api/casino/packages/dailyStreak',
    GET_EMAIL_PACKAGE: 'api/casino/package',
    GET_CUSTOMER_IP:'ip/info',
    GET_MARKETING_POPUP:'banner/all',
    CHECK_USER: "banner/click",
    USER_CURRENCY_CHANGE:"/casino/user/currency",
    CRYPTO_CURRENCY_LIST: "api/currency/list",
    GET_CURRENCY_LIST_USER: "api/currency/list",
    GET_LEADERBOARD: "dashboard/leaderboard",
    GET_TOPWINS: "dashboard/topwins",
    RAKEBACK_DAILY: "rakeback/user/daily",
    RAKEBACK_WEEKLY: "rakeback/user/weekly",
    RAKEBACK_MONTHLY: "rakeback/user/monthly",
    RAKEBACK_CLAIM: "rakeback/user/claim",
    HAPPY_HOUR_STATUS: "happyHour/status", // append /{userId}
    HAPPY_HOUR_RECAP: "happyHour/recap", // append /{userId}
    HAPPY_HOUR_EARN: "happyHour/earn",
    HAPPY_HOUR_CLAIM: "happyHour/claim", // POST, append /{userId}
    GET_ACTIVE_LOTTERY: "lottery/active",
    GET_ALL_ACTIVE_LOTTERY: "lottery/active/all",
    GET_MY_LOTTERY_TICKETS: "lottery/tickets", // append /{userId}
    BUY_LOTTERY_TICKET: "lottery/buy",
    GET_LOTTERY_RESULTS: "lottery/results",
  },
  mode: "Development",
};

export const GameplayEndPoints = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL_GAME_PLAY,
  imageCDN: "https://cdn.spinsagacasino.com:5000/",
  api: {
    GAME_LAUNCH_URL:'games/game-launch',
    KGAME_LAUNCH_URL:'kagaming-games/game-launch',
    BLAZ_LAUNCH_URL:'blazegaming/gameLaunch',
    MASCOT_LAUNCH_URL:'mascot/game-launch',
    GAMETECH_LAUNCH_URL:'gametech/gamelauncher/play',
    REVOLVER_LAUNCH_URL:'revolver/game-launch'
  },
  mode: "Development",
};

export const LOCATION_API = "https://ipapi.co/json/";
export const VPN_API =
  "https://vpnapi.io/api/?key=1d9dce1a6d5649f8869bba781bf1cf65";

export const Image_Url =
  "https://elasticbeanstalk-us-east-1-715244717776.s3.amazonaws.com/team/";
export const SportImage_Url =
  "https://elasticbeanstalk-us-east-1-715244717776.s3.amazonaws.com/sports/";
export const LeagueImage_Url =
  "https://elasticbeanstalk-us-east-1-715244717776.s3.amazonaws.com/leagues/";
export const API_URL = "";
export const Voucher_Url =
  "https://elasticbeanstalk-us-east-1-715244717776.s3.amazonaws.com";

export const PaymentEndpoints = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL_PAYMENT || "http://localhost:8080/",
  api: {
    ACTIVATE: "api/payment/enroll",
    WALLET: "api/payment/wallet",
    INFORMATION: "api/payment/information/",
    deposit_WithDraw: "api/payment/transfers",
    fabiwallet: "api/payment/information",
    SKRILL_WALLET: "api/skrillcustomer/payment",
    DEPOSIT_PAYMENT: "api/casino/payment",
    GETGAMES: "getgames",
    FAILED_DEPOSIT: "api/casino/failedpayment",
    SKRILL_ADD: "api/casino/addpayment",
    TEST_PAYMENT: "api/test-payments",
    ADD_PAYMENT_METHOD: "api/stripe/addpayment",
    CONFIRM_PAYMENT_METHOD: "api/stripe/payment",
    LIVE_GAME_LAUNCH: "launch",
    LIVE_BG_GAMEING_LAUNCH:"bgaminglaunch",
    GET_CRYPTO_CURRENCY: "getcurrencies",
    // CRYPTO_PAYMENT: "payment",
    CRYPTO_PAYMENT: "api/casino/crypto-payment",
    CREATE_CUSTOMER: "api/casino/createcustomer",
    CARD_INFO_BY_ID: "api/casino/cards",
    // GET_PAYMENT_DETAILS:'getPaymentDetailsByPaymentId',
    GET_PAYMENT_DETAILS: 'api/casino/getPaymentDetailsByPaymentId',
    ADD_CRYPTO: 'api/casino/addUserCyrpto',
    GET_CRYPTO_BY_USER: 'api/casino/userAddress',
    CURRENCY_CONVERT: "currency/convert",
  },
};

export const sportEndPoint = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL_SPORT,
  api: {},

  mode: "Development",
};

export const appVersion = {
  version: "1.0.0",
};

export default {};

//us ethis url for the stripe payment
export const CASINO_US_WEBSITE = "https://stage.spinsaga.us/"; ///stage
// "https://www.spinsaga.us/";   //Prod url
// 'http://localhost:3001/'   // local url

console.log("process",process.env);
